import inject from "scripts/ioc/inject";
import BaseMediaSalvattoreTileView from "scripts/views/baseMediaSalvattoreTileView";

import templateAnthologyCollectionSalvattoreTile from "templates/anthologyCollectionSalvattoreTile.hbs";

class AnthologyCollectionSalvattoreTileView extends BaseMediaSalvattoreTileView {
  constructor(options, securityService = inject("securityService")) {
    super(options, securityService);
  }

  get template() {
    return templateAnthologyCollectionSalvattoreTile;
  }
}

export default AnthologyCollectionSalvattoreTileView;
